import {onViewportEnter} from './lazyInit';

const loadArrangementListMainContent = async (extraParams) => {
	const {'default': formatDate} = await import(
			/* webpackChunkName: "formatDate" */
			`../locales/${globalParams.siteLocale}/formatDate`
		),
		{'default': ArrangementListPageContent} = await import(
			/* webpackChunkName: "arrangementListPageContent" */
			'../components/arrangementListPageContent'
		);

	onViewportEnter(
		document.querySelectorAll('#arrangementsList, .filterGroupContainer, .filteredArrangementsContainer'),
		() => {
			const params = extraParams
											? $.extend({}, window.arrangementListPageParams, extraParams)
											: window.arrangementListPageParams;

			new ArrangementListPageContent(params, formatDate);
		}
	);
};

export {loadArrangementListMainContent};